
jQuery("document").ready(gsap_run);

const is_mobile = window.innerWidth < 800 ? true : false;
 
function gsap_run(){


    const pagerows = gsap.utils.toArray('.fullwidthrow');
    pagerows.forEach((row) => {


        gsap.from(row, {
            scrollTrigger: {
                start: 'top bottom',
                end: 'bottom top',
                trigger: row,
                onEnter() {
                    document.body.classList.add(row.id)
                    let rowid = row.id;
                },
                onLeave() {
                    document.body.classList.remove(row.id)
                    let rowid = row.id;
                },
                onEnterBack() {
                    document.body.classList.add(row.id)
                    let rowid = row.id;
                },
                onLeaveBack() {
                    document.body.classList.remove(row.id)
                    let rowid = row.id;
                }
            },
            opacity: 0.4,
            duration: 2
          });

    });


    /* STEPS - START*/
    const how_ST = {
        trigger: "#how",
        start: "top 75%",
        bottom: "bottom bottom",
        toggleActions: "restart reverse restart reverse "
    };
    gsap.from("#how .section_title", {
        scrollTrigger: how_ST,
        x: -400,
        duration: 0.5,
        delay: 0.2
    });
    const steps = document.querySelectorAll(".step_section");
    if(gsap){
        steps.forEach(i => i.classList.add("enableblur"));
    }
    for(i=0; i<steps.length; i++) {
        gsap.to(steps[i], {
            scrollTrigger: {
                trigger: steps[i],
                start: i==0 ? "top bottom" : "top center",
                end: i==(steps.length - 1) ? "bottom top" : "bottom center",
                toggleActions: "restart reverse restart reverse ",
                toggleClass: 'focus',
            },
        })
    };
    /* STEPS - END */



    
    /* WHY - START*/

    const why_ST = {
        trigger: "#why",
        start: "top 75%",
        bottom: "bottom bottom",
        toggleActions: "restart reverse restart reverse "
    };
    
    gsap.from("#why .section_title", {
        scrollTrigger: why_ST,
        x: -400,
        opacity: 0,
        duration: 0.5,
        delay: 0.1
    });
    gsap.from("#why .subtitle", {
        scrollTrigger: why_ST,
        x: -400,
        opacity: 0,
        duration: 0.5,
        delay: 0.2
    });
    gsap.from("#why .why_newsection", {
        scrollTrigger: why_ST,
        y: 200,
        opacity: 0,
        duration: 0.5,
        delay: 0.3
    });
    // gsap.from("#why ._simple", {
    //     scrollTrigger: why_ST,
    //     x: -400,
    //     opacity: 0,
    //     duration: 0.5,
    //     delay: 0.4
    // });
    // gsap.utils.toArray(".why_item").forEach((value, index) => 
    //     gsap.from(value, {
    //         scrollTrigger: why_ST,
    //         scale: 0.6,
    //         opacity: 0,
    //         duration: 0.5,
    //         delay: 0.5 + (0.1 * index),
    //     })
    // );




    /* WHY - END*/



    
    /* TOPTIPS - START*/
    const toptips_ST = {
        trigger: "#toptips",
        start: "top 75%",
        bottom: "bottom bottom",
        toggleActions: "restart reverse restart reverse "
    };
    
    gsap.from("#toptips .section_title", {
        scrollTrigger: toptips_ST,
        x: -400,
        opacity: 0,
        duration: 0.5,
        delay: 0.1
    });
    gsap.from("#toptips .section_title_under", {
        scrollTrigger: toptips_ST,
        x: -400,
        opacity: 0,
        duration: 0.5,
        delay: 0.2
    });
    gsap.utils.toArray(".tipItem").forEach((value, index) => 
        gsap.from(value, {
            scrollTrigger: toptips_ST,
            y: 100,
            opacity: 0,
            duration: 0.5,
            delay: 0.5 + (0.1 * index),
        })
    );
    
    /* TOPTIPS - END*/



    
    /* VIDEOBOTTOM - START*/
    const vidbottom_ST = {
        trigger: "#video_bottom",
        start: "top 55%",
        bottom: "bottom bottom",
        toggleActions: "restart reverse restart reverse "
    };
    gsap.from("#video_bottom .section_title", {
        scrollTrigger: vidbottom_ST,
        x: -400,
        opacity: 0,
        duration: 0.5,
        delay: 0.1
    });
    gsap.from("#video_bottom p", {
        scrollTrigger: vidbottom_ST,
        y: 40,
        opacity: 0,
        duration: 0.5,
        delay: 0.2
    });
    gsap.from("#video_bottom iframe", {
        scrollTrigger: vidbottom_ST,
        y: 60,
        opacity: 0,
        duration: 0.5,
        delay: 0.3
    });
    
    /* VIDEOBOTTOM - END*/



    
    /* WHAT - START*/

    const what_ST = {
        trigger: "#what",
        start: "top bottom",
        bottom: "bottom bottom",
        toggleActions: "restart reverse restart reverse "
    };

    gsap.from("#what .section_title ", {
        scrollTrigger: what_ST,
        x: -400,
        opacity: 0,
        duration: 0.5,
        delay: 0.1
    });
    gsap.from("#what .what_icon", {
        scrollTrigger: what_ST,
        scale: 0,
        opacity: 0,
        duration: 0.5,
        delay: 0.4
    });
    gsap.from("#what .column_box_img img", {
        scrollTrigger: what_ST,
        x: -100,
        opacity: 0,
        duration: 0.5,
        delay: 0.5
    });
    gsap.from("#what .column_box_img .numofpackages", {
        scrollTrigger: what_ST,
        x: -100,
        opacity: 0,
        duration: 0.5,
        delay: 0.6
    });
    gsap.from("#what .column_box_img .numofpackages_subtitle", {
        scrollTrigger: what_ST,
        x: -100,
        opacity: 0,
        duration: 0.5,
        delay: 0.7
    });

    /* WHAT - END*/


    
    /* WHERE - START*/
    const where_ST = {
        trigger: "#where",
        start: "top 75%",
        bottom: "bottom bottom",
        toggleActions: "restart reverse restart reverse "
    };
    gsap.from("#where .section_title", {
        scrollTrigger: where_ST,
        x: -400,
        opacity: 0,
        duration: 0.5,
        delay: 0.2
    });
    gsap.utils.toArray(".where_icon").forEach((value, index) => 
        gsap.from(value, {
            scrollTrigger: where_ST,
            x: -100,
            opacity: 0,
            duration: 0.6,
            delay: 0.6 + (0.1 * index),
        })
    );
    
    gsap.from("#where .column_room_media", {
        scrollTrigger: where_ST,
        y: 100,
        opacity: 0,
        duration: 0.5,
        delay: 0.7
    });
    /* WHERE - END*/

}



jQuery("document").ready(function(){
    function scroller(linkid, targetid){
        jQuery(linkid).click(function(){
            jQuery('html, body').animate({
                scrollTop: jQuery(targetid).offset().top}, 'slow');
        })
    }
    scroller("#nav_what", "#what");
    scroller("#nav_where", "#where");
    scroller("#nav_how", "#how");
    scroller("#nav_why", "#why");
    scroller("#nav_tips", "#toptips");
    scroller("#nav_attempt", "#video_bottom");
});